<ng-content select="mc-switch-board-bar, [mcSwitchBoardBar]"></ng-content>
<ng-content select="mc-switch-board-content, [mcSwitchBoardContent]"></ng-content>